import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { HelpCenterListPage } from '@/features/help-center'

export const Route = createFileRoute('/_authenticated/_main/central-de-ajuda/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Central de Ajuda') }]
  }),
  component: HelpCenterListPage
})
